<template>
  <div>
    <VueMarkdown :source="content" />
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: { VueMarkdown },
  props: {
    content: {
      type: String,
      default: "",
    },
  },
};
</script>
